import { toast } from 'sonner';
import type { CalibrationCertificate } from '../types';
import { formatCertificateDate } from './certificateStatus';

// Legacy parity: posts a small label payload to the in-office label printer
// reachable at https://10.0.70.165/api/print/text. Matches the AngularJS
// implementation in apps/frontend/.../calibrationrecords-page.component.js.
export function printProbeTag(cert: CalibrationCertificate): void {
  const dueDate = cert.dueDate ? formatCertificateDate(cert.dueDate) : '';
  const equipmentName = cert.equipmentName || '';
  const equipmentType = cert.equipmentType || '';
  const probeSerial = cert.streamSerialNumber || '';

  const text = [
    `ATEK Calibration${equipmentName ? `           ${equipmentName}` : ''}`,
    `Certificate: ${cert.certNumber || ''} Exp:${dueDate}`,
    `Probe: ${probeSerial}`,
    `Equipment: ${equipmentType}`,
  ].join('\n');

  const body = new URLSearchParams({
    text,
    printer: '2',
    quantity: '1',
    font_size: '40',
    align: 'left',
    margin_left: '0',
    margin_top: '0',
    margin_bottom: '30',
  });

  fetch('https://10.0.70.165/api/print/text', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    },
    body: body.toString(),
  })
    .then((res) => {
      if (!res.ok) throw new Error(`Print failed: ${res.status}`);
      toast.success(`Probe tag printed for ${cert.certNumber}`);
    })
    .catch((err) => {
      console.error('Print probe tag failed:', err);
      toast.error('Failed to print probe tag', {
        description: err instanceof Error ? err.message : String(err),
      });
    });
}
